import { render, staticRenderFns } from "./RequirementItem.vue?vue&type=template&id=6714c435&scoped=true&"
import script from "./RequirementItem.vue?vue&type=script&lang=ts&"
export * from "./RequirementItem.vue?vue&type=script&lang=ts&"
import style0 from "./RequirementItem.vue?vue&type=style&index=0&id=6714c435&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6714c435",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
installComponents(component, {VCard,VCardText,VCardTitle,VDialog})
